// Packages
import Cookies from 'js-cookie';
import { nanoid } from 'nanoid';

export default defineNuxtPlugin((nuxtApp) => {
  
  return {
    provide: {
      signRoute: (params?: Record<any, any>) => {
        const app = nuxtApp.vueApp.$nuxt;

        const redirectUrl = new URL(`${nuxtApp.$config.public.DOMAIN}/${app.$i18n.locale.value}/authorize`);
        const accountsPath = new URL(`${nuxtApp.$config.public.NNP_ACCOUNTS_URL}/oauth2/authorize`);

        let callback = new URL(`${nuxtApp.$config.public.DOMAIN}/${app._route.fullPath}`);
        
        if (params?.goToCheckout) {
          callback = new URL(`${nuxtApp.$config.public.DOMAIN}/${app.$i18n.locale.value}/store/checkout`);
          callback.searchParams.append('product_slug', params.product_slug);
          callback.searchParams.append('variant_id', params.variant_id);
        }

        redirectUrl.searchParams.append('cb', encodeURIComponent(callback.toString()));

        accountsPath.searchParams.append('lang', app.$i18n.locale.value);
        accountsPath.searchParams.append('redirect_url', encodeURIComponent(redirectUrl.toString()));
        accountsPath.searchParams.append('client_id', process.env.CLIENT_ID!);

        return window.location.href = accountsPath.toString();
      }
    }
  }
})
